import { RootState } from '@redux/store'

export const userAccountTypeSelector = ({ account }: RootState) =>
  account.accountMode
